import { Button, Image, Input, Popconfirm, Rate, Select, Switch } from "antd";
import {
  DeleteOutlined,
  DownloadOutlined,
  EditOutlined,
  EyeOutlined,
  BellOutlined,
} from "@ant-design/icons";
import logo from "../../asset/logos/icon.svg";
import stars from "../../asset/icons/star.svg";
import emptyStars from "../../asset/icons/emptyStar.svg";
import { ROLES } from "../functions";

const alphanumericSort = (a, b, value) => {
  if (isNaN(parseInt(a[value]))) {
    return a[value]?.localeCompare(b[value]);
  }
  return a[value] - b[value];
};

const RenderActionButtons = (value) => {
  let ButtonsArray = [];
  if (value?.Delete) {
    ButtonsArray.push(RenderDeleteButton(value.Delete));
  }
  if (value?.Edit) {
    ButtonsArray.push(RenderEditButton(value.Edit));
  }
  if (value?.View) {
    ButtonsArray.push(RenderViewButton(value.View));
  }
  if (value?.Download) {
    ButtonsArray.push(RenderDownloadButton(value.Download));
  }
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-around",
        // paddingRight: "5px",
      }}
    >
      {ButtonsArray?.map((el, i) => (
        <div key={i}>{el}</div>
      ))}
    </div>
  );
};

// Delete Button
const RenderDeleteButton = (value) => {
  const { id, onClick } = value;
  return (
    <Popconfirm title="Sure to Delete?" onConfirm={() => onClick(id)}>
      <Button type="primary">
        {value?.name ? value?.name : <DeleteOutlined />}
      </Button>
      {/* <Button type="primary">{value?.name}</Button> */}
    </Popconfirm>
  );
};

// Delete button without confimation model
const RenderDeleteWithoutConfirmation = (value) => {
  return (
    <Popconfirm
      title="Sure to Delete?"
      open={false}
      onOpenChange={() => value?.onClick(value.key)}
      onConfirm={() => value?.onClick(value.key)}
    >
      {value?.name ? (
        value?.name
      ) : (
        <DeleteOutlined style={{ color: "black" }} />
      )}
    </Popconfirm>
  );
};
// Download Button
const RenderDownloadButton = (value) => {
  return (
    <DownloadOutlined
      onClick={() => {
        window.open(value, "Download");
      }}
    />
  );
};

// Edit Button
const RenderEditButton = (value) => {
  const { id, onClick, disabled = false } = value;
  return (
    <Button
      type="primary"
      disabled={disabled}
      onClick={() => {
        onClick(id);
      }}
    >
      <EditOutlined />
    </Button>
  );
};

// Render View Button
const RenderViewButton = (value) => {
  // console.log(value);
  const { id = null, onClick = () => { } } = value;
  return (
    <Button
      onClick={() => {
        // console.log('click');
        onClick(id);
      }}
      type="primary"
    >
      <EyeOutlined />
    </Button>
  );
};

// Render View Button
const RenderNotificationButton = (value) => {
  // console.log(value);
  const { id = null, onClick = () => { } } = value;
  return (
    <Button
      onClick={() => {
        onClick(id);
      }}
      type="primary"
    >
      <BellOutlined />
    </Button>
  );
};

// Render Images
const ImageRanders = (value) => {
  // console.log(value);
  let imageSrc = value;
  if (!imageSrc) {
    imageSrc = logo;
  }
  return (
    <div>
      <Image
        width={50}
        height={50}
        className="rounded-full object-cover"
        src={imageSrc}
        alt={value}
      />
    </div>
  );
};

// Render Banner
const BannerRanders = (value) => {
  let imageSrc = value;
  if (!imageSrc) {
    imageSrc = logo;
  }
  return (
    <div>
      <Image
        width={200}
        height={80}
        className="rounded-md object-cover"
        src={imageSrc}
        alt={value}
      />
    </div>
  );
};

// Toggle Button
const RenderToggleButton = (value) => {
  // console.log(value);
  const { checked, id, onClick } = value;
  return (
    <div>
      <Switch
        onChange={() => {
          onClick(id, checked);
        }}
        checked={!checked}
      />
    </div>
  );
};

// QR Button
const RenderQrButton = (value = {}) => {
  const { id, onClick, isDisable = false } = value;
  return (
    <Button
      type="primary"
      disabled={isDisable}
      onClick={() => {
        onClick(id);
      }}
    >
      Generate QR
    </Button>
  );
};

// Ratings
const RenderRating = (value) => {
  // console.log(value);
  const { ratings } = value;
  return (
    <div>
      {/* {ratings}&nbsp;< StarFilled /> */}

      <Rate
        disabled
        allowHalf
        value={ratings}
        character={({ index }) => {
          if (index < ratings) {
            return <img src={stars} />;
          } else {
            return <img src={emptyStars} />;
          }
        }}
      />
    </div>
  );
};

const RenderButtonWithIcon = (value) => {
  // console.log(value);
  const { id = null, onClick = () => { }, icon = null } = value;
  return (
    <Button
      onClick={() => {
        onClick(id);
      }}
      type="primary"
    >
      {icon}
    </Button>
  );
};
export const loginRoot = "/";
export const appRoot = "/app";

const CONSTANTS = {
  BASE_URL: process.env.REACT_APP_BASE_URL,
  GETMe: null,
  TABLE: {
    USERS: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 80,
      },
      {
        title: "View",
        dataIndex: "view",
        render: RenderViewButton,
        width: 50,
      },
      {
        title: "Profile",
        dataIndex: "profilePic",
        render: ImageRanders,
        width: 70,
      },
      {
        title: "Name",
        dataIndex: "name",
        sorter: (a, b) => alphanumericSort(a, b, "name"),
        width: 90,
      },
      {
        title: "Mobile No.",
        dataIndex: "mobile",
        sorter: (a, b) => alphanumericSort(a, b, "mobile"),
        width: 110,
      },

      {
        title: "Email",
        dataIndex: "email",
        sorter: (a, b) => alphanumericSort(a, b, "email"),
        width: 130,
      },

      {
        title: "Notification",
        dataIndex: "notification",
        render: RenderNotificationButton,
        width: 70,
      },
    ],

    USER_PETS: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 100,
      },
      {
        title: "View",
        dataIndex: "view",
        render: RenderViewButton,
        width: 90,
        // sorter: (a, b) => alphanumericSort(a, b, "no"),
      },
      {
        title: "Image",
        dataIndex: "image",
        render: ImageRanders,
        width: 80,
        // sorter: (a, b) => alphanumericSort(a, b, "no"),
      },
      {
        title: "Name",
        dataIndex: "name",
        sorter: (a, b) => alphanumericSort(a, b, "name"),
        width: 100,
      },
      {
        title: "Device Type",
        dataIndex: "deviceTypeId",
        width: 125,
      },
      {
        title: "Device ID",
        dataIndex: "Did",
        width: 130,
      },
      {
        title: "Collar ID",
        dataIndex: "collarId",
        width: 180,
      },
      {
        title: "Collar Connection",
        dataIndex: "deviceConnection",
        width: 120,
      },
      {
        title: "Device Status",
        dataIndex: "deviceStatus",
        width: 100,
      },
      {
        title: "Scan QR",
        dataIndex: "deviceQR",
        width: 100,
      },
      {
        title: "Wifi",
        dataIndex: "deviceWifi",
        width: 100,
      },
      {
        title: "Feeder Status",
        dataIndex: "feederStatus",
        width: 100,
      },
      {
        title: "Feeder Connection",
        dataIndex: "feederConnection",
        width: 120,
      },
      {
        title: "Feeder ID",
        dataIndex: "feederId",
        width: 180,
      },
      {
        title: "Feeder QR",
        dataIndex: "feederQR",
        width: 100,
      },
      {
        title: "Feeder Wifi",
        dataIndex: "feederWifi",
        width: 100,
      },
      {
        title: "Species",
        dataIndex: "species",
        sorter: (a, b) => alphanumericSort(a, b, "species"),
        width: 100,
      },

      {
        title: "Breed",
        dataIndex: "breed",
        sorter: (a, b) => alphanumericSort(a, b, "breed"),
        width: 100,
      },

      {
        title: "DOB",
        dataIndex: "dob",
        sorter: (a, b) => alphanumericSort(a, b, "dob"),
        width: 110,
      },
      {
        title: "Height (in)",
        dataIndex: "height",
        sorter: (a, b) => alphanumericSort(a, b, "height"),
        width: 120,
      },

      {
        title: "Gender",
        dataIndex: "gender",
        sorter: (a, b) => alphanumericSort(a, b, "gender"),
        width: 100,
      },
      {
        title: "Generate QR",
        dataIndex: "qrcode",
        render: RenderQrButton,
        width: 130,
      },

    ],

    SUPPORT_USER_PETS: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 100,
      },
      {
        title: "View",
        dataIndex: "view",
        render: RenderViewButton,
        width: 90,
        // sorter: (a, b) => alphanumericSort(a, b, "no"),
      },
      {
        title: "Image",
        dataIndex: "image",
        render: ImageRanders,
        width: 80,
        // sorter: (a, b) => alphanumericSort(a, b, "no"),
      },
      {
        title: "Name",
        dataIndex: "name",
        sorter: (a, b) => alphanumericSort(a, b, "name"),
        width: 100,
      },
      {
        title: "Device Type",
        dataIndex: "deviceTypeId",
        width: 125,
      },
      {
        title: "Device ID",
        dataIndex: "Did",
        width: 150,
      },
      {
        title: "Collar ID",
        dataIndex: "collarId",
        width: 180,
      },
      {
        title: "Collar Connection",
        dataIndex: "deviceConnection",
        width: 120,
      },
      {
        title: "Device Status",
        dataIndex: "deviceStatus",
        width: 100,
      },
      {
        title: "Scan QR",
        dataIndex: "deviceQR",
        width: 100,
      },
      {
        title: "Wifi",
        dataIndex: "deviceWifi",
        width: 100,
      },
      {
        title: "Feeder Status",
        dataIndex: "feederStatus",
        width: 100,
      },
      {
        title: "Feeder Connection",
        dataIndex: "feederConnection",
        width: 120,
      },
      {
        title: "Feeder ID",
        dataIndex: "feederId",
        width: 180,
      },
      {
        title: "Feeder DID",
        dataIndex: "feederDID",
        width: 180,
      },
      {
        title: "Feeder QR",
        dataIndex: "feederQR",
        width: 100,
      },
      {
        title: "Feeder Wifi",
        dataIndex: "feederWifi",
        width: 100,
      },
      {
        title: "Device QR",
        dataIndex: "qrcode",
        render: RenderQrButton,
        width: 130,
      },
      {
        title: "Feeder QR",
        dataIndex: "feederQrCode",
        render: RenderQrButton,
        width: 130,
      },
    ],

    USER_FEEDBACK: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 50,
      },

      {
        title: "Feedback",
        dataIndex: "feedback",
        sorter: (a, b) => alphanumericSort(a, b, "feedback"),
        width: 250,
      },
      {
        title: "Ratings",
        dataIndex: "rating",
        render: RenderRating,
        width: 80,
      },
    ],
    ROLE_AND_ACCESS: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 100,
      },

      {
        title: "Name",
        dataIndex: "name",
        sorter: (a, b) => alphanumericSort(a, b, "name"),
        width: 100,
      },
      {
        title: "Mobile Number",
        dataIndex: "mobile",
        sorter: (a, b) => alphanumericSort(a, b, "mobile"),
        width: 125,
      },
      {
        title: "Email",
        dataIndex: "email",
        sorter: (a, b) => alphanumericSort(a, b, "email"),
        width: 180,
      },
      {
        title: "Role",
        dataIndex: "role",
        sorter: (a, b) => alphanumericSort(a, b, "role"),
        width: 100,
        filters: [
          {
            id: "Admin",
            label: "Admin",
            text: "Admin",
            value: "Admin",
          },
          {
            id: "ClientSupport",
            label: "Client Support",
            text: "Client Support",
            value: "ClientSupport",
          },
          {
            id: "Manufacturer",
            label: "Manufacturer",
            text: "Manufacturer",
            value: "Manufacturer",
          },
        ],
        filterMultiple: false,
        onFilter: (value, record) => true,
        filterSearch: true,
      },
      {
        title: "Created At",
        dataIndex: "date",
        sorter: (a, b) => alphanumericSort(a, b, "createdAt"),
        width: 100,
      },
      {
        title: "Block",
        dataIndex: "block",
        render: RenderToggleButton,
        width: 100,
      },

      {
        title: "Edit",
        dataIndex: "editTableRow",
        render: RenderEditButton,
        width: 50,
      },
      {
        title: "Action",
        dataIndex: "deleteTableRow",
        render: RenderDeleteButton,
        width: 70,
      },
    ],
    MODE_FEEDBACK_USER: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 60,
      },
      {
        title: "Pet",
        dataIndex: "petName",
        width: 90,
      },
      {
        title: "Question",
        dataIndex: "question",
        width: 150,
      },
      {
        title: "Options",
        dataIndex: "optionsD",
        width: 90,
      },

      {
        title: "Mode",
        dataIndex: "modeD",
        filterMultiple: false,
        filters: [
          // {
          //   id: 0,
          //   text: 'SOS Mode',
          //   label: 'SOS Mode',
          //   value: 0,
          // },
          // {
          //   id: 1,
          //   text: 'Normal or Default Mode',
          //   label: 'Normal or Default Mode',
          //   value: 1,
          // },
          {
            id: 2,
            text: "Walk Mode",
            label: "Walk Mode",
            value: 2,
          },
          {
            id: 3,
            text: "Boarding Mode",
            label: "Boarding Mode",
            value: 3,
          },
          {
            id: 4,
            text: "Super Saver Mode",
            label: "Super Saver Mode",
            value: 4,
          },
        ],
        // filterMode: "tree",
        // filterSearch: true,
        width: 70,
      },
      {
        title: "Response",
        dataIndex: "response",
        sorter: (a, b) => alphanumericSort(a, b, "response"),
        width: 100,
      },
    ],
    MODE_FEEDBACK_PET: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 60,
      },
      {
        title: "User",
        dataIndex: "userName",
        width: 90,
      },
      {
        title: "Question",
        dataIndex: "question",
        width: 150,
      },
      {
        title: "Options",
        dataIndex: "optionsD",
        width: 90,
      },

      {
        title: "Mode",
        dataIndex: "modeD",
        filterMultiple: false,
        filters: [
          // {
          //   id: 0,
          //   text: 'SOS Mode',
          //   label: 'SOS Mode',
          //   value: 0,
          // },
          // {
          //   id: 1,
          //   text: 'Normal or Default Mode',
          //   label: 'Normal or Default Mode',
          //   value: 1,
          // },
          {
            id: 2,
            text: "Walk Mode",
            label: "Walk Mode",
            value: 2,
          },
          {
            id: 3,
            text: "Boarding Mode",
            label: "Boarding Mode",
            value: 3,
          },
          {
            id: 4,
            text: "Super Saver Mode",
            label: "Super Saver Mode",
            value: 4,
          },
        ],
        // filterMode: "tree",
        // filterSearch: true,
        width: 70,
      },
      {
        title: "Response",
        dataIndex: "response",
        sorter: (a, b) => alphanumericSort(a, b, "response"),
        width: 100,
      },
    ],

    USER_SUBSCRIPTION: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        // width: 100,
      },
      {
        title: "Subscription Name",
        dataIndex: "name",
        sorter: (a, b) => alphanumericSort(a, b, "name"),
        // width: 100,
      },
      {
        title: "Pet Name",
        dataIndex: "petName",
        sorter: (a, b) => alphanumericSort(a, b, "petName"),
        // width: 100,
      },
      {
        title: "Subscription Status",
        dataIndex: "status",
        sorter: (a, b) => alphanumericSort(a, b, "status"),
        // width: 100,
      },
      {
        title: "Subscription End Date",
        dataIndex: "expiryDate",
        sorter: (a, b) => alphanumericSort(a, b, "expiryDate"),
        // width: 100,
      },
    ],
    USER_TRANSACTION: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 100,
      },
      {
        title: "Name",
        dataIndex: "name",
        sorter: (a, b) => alphanumericSort(a, b, "name"),
        width: 100,
      },
      {
        title: "Payment Type",
        dataIndex: "paymentType",
        sorter: (a, b) => alphanumericSort(a, b, "paymentType"),
        width: 100,
      },
      {
        title: "Payment Id",
        dataIndex: "paymentId",
        sorter: (a, b) => alphanumericSort(a, b, "paymentId"),
        width: 120,
      },
      {
        title: "Payment Method",
        dataIndex: "paymentMethod",
        sorter: (a, b) => alphanumericSort(a, b, "paymentMethod"),
        width: 100,
      },
      {
        title: "Amount",
        dataIndex: "amount",
        sorter: (a, b) => alphanumericSort(a, b, "amount"),
        width: 100,
      },
      {
        title: "Payment Status",
        dataIndex: "status",
        sorter: (a, b) => alphanumericSort(a, b, "status"),
        width: 100,
      },
    ],
    BANNER: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 80,
      },
      {
        title: "Name",
        dataIndex: "name",
        sorter: (a, b) => alphanumericSort(a, b, "name"),
        width: 80,
      },

      {
        title: "Flag",
        dataIndex: "flagD",
        width: 100,
      },
      {
        title: "Banner",
        dataIndex: "image",
        render: BannerRanders,
        width: 160,
        // sorter: (a, b) => alphanumericSort(a, b, "no"),
      },
      {
        title: "Link",
        dataIndex: "redirectionLink",
        sorter: (a, b) => alphanumericSort(a, b, "redirectionLink"),
        width: 150,
      },

      {
        title: "Edit",
        dataIndex: "edit",
        render: RenderEditButton,
        width: 50,
      },
      {
        title: "Action",
        dataIndex: "deleteTableRow",
        render: RenderDeleteButton,
        width: 50,
      },


    ],
    PETS: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 100,
      },
      {
        title: "View",
        dataIndex: "view",
        render: RenderViewButton,
        width: 90,
        // sorter: (a, b) => alphanumericSort(a, b, "no"),
      },
      {
        title: "Image",
        dataIndex: "image",
        render: ImageRanders,
        width: 80,
        // sorter: (a, b) => alphanumericSort(a, b, "no"),
      },
      {
        title: "Name",
        dataIndex: "name",
        sorter: (a, b) => alphanumericSort(a, b, "name"),
        width: 100,
      },
      {
        title: "User",
        dataIndex: "user",
        sorter: (a, b) => alphanumericSort(a, b, "name"),
        width: 150,
      },
      {
        title: "Species",
        dataIndex: "species",
        sorter: (a, b) => alphanumericSort(a, b, "species"),
        width: 100,
      },

      {
        title: "Breed",
        dataIndex: "breed",
        sorter: (a, b) => alphanumericSort(a, b, "breed"),
        width: 150,
      },

      {
        title: "DOB",
        dataIndex: "dob",
        sorter: (a, b) => alphanumericSort(a, b, "dob"),
        width: 110,
      },
      {
        title: "Height (in)",
        dataIndex: "height",
        sorter: (a, b) => alphanumericSort(a, b, "height"),
        width: 120,
      },

      {
        title: "Gender",
        dataIndex: "gender",
        sorter: (a, b) => alphanumericSort(a, b, "gender"),
        width: 100,
      },
      // {
      //   title: "Device Type",
      //   dataIndex: "type",
      //   sorter: (a, b) => alphanumericSort(a, b, "type"),
      // },
      // {
      //   title: "Active",
      //   dataIndex: "isActive",
      //   sorter: (a, b) => alphanumericSort(a, b, "isActive"),
      // },

      // {
      //   title: "Block Pet",
      //   dataIndex: "isBlocked",
      //   render: RenderToggleButton,
      //   width: 100,
      //   // sorter: (a, b) => alphanumericSort(a, b, "no"),
      // },
    ],
    PETS_FOOD_TRACKING: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 100,
      },

      {
        title: "Product",
        dataIndex: "product",
        sorter: (a, b) => alphanumericSort(a, b, "product"),
        width: 150,
      },
      {
        title: "Quantity",
        dataIndex: "quantity",
        sorter: (a, b) => alphanumericSort(a, b, "quantity"),
        width: 100,
      },
      {
        title: "Food Type",
        dataIndex: "foodType",
        sorter: (a, b) => alphanumericSort(a, b, "foodType"),
        width: 100,
      },
      {
        title: "Food Brand",
        dataIndex: "foodBrand",
        sorter: (a, b) => alphanumericSort(a, b, "foodBrand"),
        width: 100,
      },
      {
        title: "Meal Date",
        dataIndex: "mealDate",
        sorter: (a, b) => alphanumericSort(a, b, "mealDate"),
        width: 100,
      },
      {
        title: "Meal Time",
        dataIndex: "mealTime",
        sorter: (a, b) => alphanumericSort(a, b, "mealTime"),
        width: 100,
      },
    ],
    PETS_WEIGHT_TRACKING: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 100,
      },
      {
        title: "Weight",
        dataIndex: "weight",
        sorter: (a, b) => alphanumericSort(a, b, "weight"),
        width: 100,
      },
      {
        title: "RIB Test",
        dataIndex: "RIBTest",
        sorter: (a, b) => alphanumericSort(a, b, "RIBTest"),
        width: 100,
      },
      {
        title: "Date",
        dataIndex: "date",
        sorter: (a, b) => alphanumericSort(a, b, "date"),
        width: 100,
      },
      {
        title: "isSprayed",
        dataIndex: "isSprayed",
        // sorter: (a, b) => alphanumericSort(a, b, "date"),
        width: 100,
      },
      {
        title: "isNeutered",
        dataIndex: "isNeutered",
        // sorter: (a, b) => alphanumericSort(a, b, "date"),
        width: 100,
      },
    ],
    PETS_MANUALLY_TRACKING: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 100,
      },
      {
        title: "Activity",
        dataIndex: "name",
        sorter: (a, b) => alphanumericSort(a, b, "name"),
        width: 100,
      },
      {
        title: "Duration",
        dataIndex: "duration",
        sorter: (a, b) => alphanumericSort(a, b, "duration"),
        width: 100,
      },
      {
        title: "Date",
        dataIndex: "date",
        sorter: (a, b) => alphanumericSort(a, b, "date"),
        width: 100,
      },
    ],

    BENCHMARK: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 100,
      },
      {
        title: "View",
        dataIndex: "view",
        render: RenderViewButton,
        width: 90,
        // sorter: (a, b) => alphanumericSort(a, b, "no"),
      },

      {
        title: "Breed",
        dataIndex: "breed",
        sorter: (a, b) => alphanumericSort(a, b, "breed"),
        width: 140,
      },
      {
        title: "Size",
        dataIndex: "size",
        sorter: (a, b) => alphanumericSort(a, b, "size"),
        width: 90,
      },
      {
        title: "Female Lower Weight (kg)",
        dataIndex: "lowerWeightFemale",
        sorter: (a, b) => alphanumericSort(a, b, "lowerWeightFemale"),
        width: 140,
      },
      {
        title: "Female Higher Weight (kg)",
        dataIndex: "heigherWeightFemale",
        sorter: (a, b) => alphanumericSort(a, b, "heigherWeightFemale"),
        width: 150,
      },
      {
        title: "Male Lower Weight (kg)",
        dataIndex: "lowerWeightMale",
        sorter: (a, b) => alphanumericSort(a, b, "lowerWeightMale"),
        width: 140,
      },
      {
        title: "Male Higher Weight (kg)",
        dataIndex: "heigherWeightMale",
        sorter: (a, b) => alphanumericSort(a, b, "heigherWeightMale"),
        width: 140,
      },

      {
        title: "Edit",
        dataIndex: "editTableRow",
        render: RenderEditButton,
        width: 100,
      },
      {
        title: "Action",
        dataIndex: "deleteTableRow",
        render: RenderDeleteButton,
        width: 100,
      },
    ],
    BENCHMARK_ACTIVITY: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 100,
      },

      {
        title: "Start Age",
        dataIndex: "startAge",
        sorter: (a, b) => alphanumericSort(a, b, "startAge"),
        width: 100,
      },
      {
        title: "End Age",
        dataIndex: "endAge",
        sorter: (a, b) => alphanumericSort(a, b, "endAge"),
        width: 100,
      },
      {
        title: "Walk Time (Min)",
        dataIndex: "walkTime",
        sorter: (a, b) => alphanumericSort(a, b, "walkTime"),
        width: 100,
      },
      {
        title: "Play Time (Min)",
        dataIndex: "playTime",
        sorter: (a, b) => alphanumericSort(a, b, "playTime"),
        width: 100,
      },
      {
        title: "Sleep Time (Min)",
        dataIndex: "sleepTime",
        sorter: (a, b) => alphanumericSort(a, b, "sleepTime"),
        width: 100,
      },
      {
        title: "Rest Time (Min)",
        dataIndex: "restTime",
        sorter: (a, b) => alphanumericSort(a, b, "restTime"),
        width: 100,
      },

      {
        title: "Edit",
        dataIndex: "editTableRow",
        render: RenderEditButton,
        width: 100,
      },
      {
        title: "Action",
        dataIndex: "deleteTableRow",
        render: RenderDeleteButton,
        width: 100,
      },
    ],
    FEEDBACK: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 40,
      },
      {
        title: "View",
        dataIndex: "view",
        render: RenderViewButton,
        width: 30,
      },

      {
        title: "Feedback",
        dataIndex: "feedback",
        sorter: (a, b) => alphanumericSort(a, b, "feedback"),
        width: 190,
      },
    ],

    FEEDBACK_DETAIL: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 90,
      },

      {
        title: "User",
        dataIndex: "user",
        sorter: (a, b) => alphanumericSort(a, b, "user"),
        width: 100,
      },
      {
        title: "Mobile",
        dataIndex: "mobile",
        sorter: (a, b) => alphanumericSort(a, b, "mobile"),
        width: 100,
      },
      {
        title: "Email",
        dataIndex: "email",
        sorter: (a, b) => alphanumericSort(a, b, "email"),
        width: 130,
      },

      {
        title: "Ratings",
        dataIndex: "rating",
        render: RenderRating,
        width: 150,
      },
    ],

    MODE_HISTORY: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 120,
      },
      {
        title: "View",
        dataIndex: "view",
        render: RenderViewButton,
        width: 80,
      },
      {
        title: "Mode",
        dataIndex: "modeD",
        filterMultiple: false,
        filters: [
          // {
          //   id: 0,
          //   text: 'SOS Mode',
          //   label: 'SOS Mode',
          //   value: 0,
          // },
          // {
          //   id: 1,
          //   text: 'Normal or Default Mode',
          //   label: 'Normal or Default Mode',
          //   value: 1,
          // },
          {
            id: 2,
            text: "Walk Mode",
            label: "Walk Mode",
            value: 2,
          },
          {
            id: 3,
            text: "Boarding Mode",
            label: "Boarding Mode",
            value: 3,
          },
          {
            id: 4,
            text: "Super Saver Mode",
            label: "Super Saver Mode",
            value: 4,
          },
        ],
        // filterMode: "tree",
        // filterSearch: true,
        width: 120,
      },
      {
        title: "Start Time",
        dataIndex: "startTimeD",
        width: 100,
      },
      {
        title: "End Time",
        dataIndex: "endTimeD",
        width: 100,
      },
      {
        title: "Step Taken",
        dataIndex: "stepTaken",
        sorter: (a, b) => alphanumericSort(a, b, "stepTaken"),
        width: 100,
      },
      {
        title: "Walk Duration",
        dataIndex: "walkDuration",
        sorter: (a, b) => alphanumericSort(a, b, "walkDuration"),
        width: 100,
      },
      {
        title: "Sleep Duration",
        dataIndex: "sleepDuration",
        sorter: (a, b) => alphanumericSort(a, b, "sleepDuration"),
        width: 100,
      },
      {
        title: "Play Duration",
        dataIndex: "playDuration",
        sorter: (a, b) => alphanumericSort(a, b, "playDuration"),
        width: 100,
      },
      {
        title: "Rest Duration",
        dataIndex: "restDuration",
        sorter: (a, b) => alphanumericSort(a, b, "restDuration"),
        width: 100,
      },
      {
        title: "Calories Burn In Walk",
        dataIndex: "caloriesBurnInWalk",
        sorter: (a, b) => alphanumericSort(a, b, "caloriesBurnInWalk"),
        width: 100,
      },
      {
        title: "Calories Burn In Sleep",
        dataIndex: "caloriesBurnInSleep",
        sorter: (a, b) => alphanumericSort(a, b, "caloriesBurnInSleep"),
        width: 100,
      },
      {
        title: "Calories Burn In Rest",
        dataIndex: "caloriesBurnInRest",
        sorter: (a, b) => alphanumericSort(a, b, "caloriesBurnInRest"),
        width: 100,
      },
      {
        title: "Calories Burn In Play",
        dataIndex: "caloriesBurnInPlay",
        sorter: (a, b) => alphanumericSort(a, b, "caloriesBurnInPlay"),
        width: 100,
      },
      {
        title: "isRead",
        dataIndex: "isReadD",
        width: 100,
      },
      {
        title: "Active",
        dataIndex: "activeD",
        width: 100,
      },
    ],
    MODE_FEEDBACK: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 60,
      },
      {
        title: "View",
        dataIndex: "view",
        render: RenderViewButton,
        width: 40,
      },

      {
        title: "Question",
        dataIndex: "question",
        sorter: (a, b) => alphanumericSort(a, b, "question"),
        width: 190,
      },
      {
        title: "Options",
        dataIndex: "optionsD",
        width: 100,
      },
      {
        title: "Mode",
        dataIndex: "modeD",
        filterMultiple: false,
        filters: [
          // {
          //   id: 0,
          //   text: 'SOS Mode',
          //   label: 'SOS Mode',
          //   value: 0,
          // },
          // {
          //   id: 1,
          //   text: 'Normal or Default Mode',
          //   label: 'Normal or Default Mode',
          //   value: 1,
          // },
          {
            id: 2,
            text: "Walk Mode",
            label: "Walk Mode",
            value: 2,
          },
          {
            id: 3,
            text: "Boarding Mode",
            label: "Boarding Mode",
            value: 3,
          },
          {
            id: 4,
            text: "Super Saver Mode",
            label: "Super Saver Mode",
            value: 4,
          },
        ],
        // filterMode: "tree",
        // filterSearch: true,
        width: 70,
      },

      {
        title: "Edit",
        dataIndex: "editTableRow",
        render: RenderEditButton,
        width: 40,
      },
      {
        title: "Action",
        dataIndex: "deleteTableRow",
        render: RenderDeleteButton,
        width: 40,
      },
    ],
    USER_MODE_FEEDBACK: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 80,
      },

      {
        title: "User",
        dataIndex: "user",
        sorter: (a, b) => alphanumericSort(a, b, "user"),
        width: 100,
      },
      {
        title: "Mobile",
        dataIndex: "mobile",
        sorter: (a, b) => alphanumericSort(a, b, "mobile"),
        width: 100,
      },
      {
        title: "Email",
        dataIndex: "email",
        sorter: (a, b) => alphanumericSort(a, b, "email"),
        width: 130,
      },

      {
        title: "Mode",
        dataIndex: "modeD",
        // filterMultiple: false,
        // filters: [
        //   // {
        //   //   id: 0,
        //   //   text: 'SOS Mode',
        //   //   label: 'SOS Mode',
        //   //   value: 0,
        //   // },
        //   {
        //     id: 1,
        //     text: 'Normal or Default Mode',
        //     label: 'Normal or Default Mode',
        //     value: 1,
        //   },
        //   {
        //     id: 2,
        //     text: 'Walk Mode',
        //     label: 'Walk Mode',
        //     value: 2,
        //   },
        //   {
        //     id: 3,
        //     text: 'Boarding Mode',
        //     label: 'Boarding Mode',
        //     value: 3,
        //   },
        //   {
        //     id: 4,
        //     text: 'Super Saver Mode',
        //     label: 'Super Saver Mode',
        //     value: 4,
        //   },
        // ],
        // filterMode: "tree",
        // filterSearch: true,
        width: 90,
      },
      {
        title: "Response",
        dataIndex: "response",
        sorter: (a, b) => alphanumericSort(a, b, "response"),
        width: 200,
      },
    ],
    DEVICETYPE: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 70,
      },
      {
        title: "Image",
        dataIndex: "image",
        render: ImageRanders,
        width: 70,
      },
      {
        title: "View",
        dataIndex: "view",
        render: RenderViewButton,
        width: 50,
      },
      {
        title: "Type",
        dataIndex: "type",
        sorter: (a, b) => alphanumericSort(a, b, "type"),
        width: 70,
      },
      {
        title: "Title",
        dataIndex: "title",
        sorter: (a, b) => alphanumericSort(a, b, "title"),
        width: 70,
      },
      {
        title: "Description",
        dataIndex: "description",
        sorter: (a, b) => alphanumericSort(a, b, "description"),
        width: 150,
      },
      {
        title: "Price (₹)",
        dataIndex: "price",
        sorter: (a, b) => alphanumericSort(a, b, "price"),
        width: 60,
      },
    ],

    DEVICE_1: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 100,
      },
      {
        title: "View",
        dataIndex: "view",
        render: RenderViewButton,
        width: 80,
      },

      {
        title: "Unique Id",
        dataIndex: "uniqueIdD",
        sorter: (a, b) => alphanumericSort(a, b, "uniqueId"),
        width: 200,
      },
      {
        title: "Firmware Version",
        dataIndex: "firmwareVersion",
        sorter: (a, b) => alphanumericSort(a, b, "firmwareVersion"),
        width: 120,
      },
      {
        title: "Device Id",
        dataIndex: "DID",
        sorter: (a, b) => alphanumericSort(a, b, "DID"),
        width: 120,
      },
      {
        title: "PCB Id",
        dataIndex: "pcbId",
        sorter: (a, b) => alphanumericSort(a, b, "pcbId"),
        width: 100,
      },
      {
        title: "IMEI Number",
        dataIndex: "imeiNumber",
        sorter: (a, b) => alphanumericSort(a, b, "imeiNumber"),
        width: 100,
      },
      {
        title: "Battery ID",
        dataIndex: "batteryId",
        sorter: (a, b) => alphanumericSort(a, b, "batteryId"),
        width: 120,
      },

      {
        title: "isActive",
        dataIndex: "isActive",
        width: 130,
      },
      {
        title: "QR Code",
        dataIndex: "qrcode",
        render: RenderQrButton,
        width: 130,
      },

      {
        title: "Action",
        dataIndex: "deleteTableRow",
        render: RenderDeleteButton,
        width: 130,
      },
    ],

    DEVICE_2: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 100,
      },
      {
        title: "View",
        dataIndex: "view",
        render: RenderViewButton,
        width: 80,
      },

      {
        title: "Unique Id",
        dataIndex: "uniqueIdD",
        sorter: (a, b) => alphanumericSort(a, b, "uniqueId"),
        width: 200,
      },
      {
        title: "Device Type",
        dataIndex: "deviceTypeId",
        filters: [
          {
            id: "FlufFit 1",
            label: "FlufFit 1",
            text: "FlufFit 1",
            value: "1",
          },
          {
            id: "FlufFit 2",
            label: "FlufFit 2",
            text: "FlufFit 2",
            value: "2",
          },
        ],
        filterMultiple: false,
        onFilter: (value, record) => true,
        filterSearch: true,
        width: 130,
      },
      {
        title: "Version",
        dataIndex: "firmwareVersion",
        sorter: (a, b) => alphanumericSort(a, b, "firmwareVersion"),
        width: 100,
      },
      {
        title: "Device Id",
        dataIndex: "DID_D",
        sorter: (a, b) => alphanumericSort(a, b, "DID"),
        width: 170,
      },
      {
        title: "PCB Id",
        dataIndex: "pcbId",
        sorter: (a, b) => alphanumericSort(a, b, "pcbId"),
        width: 100,
      },
      {
        title: "IMEI Number",
        dataIndex: "imeiNumber",
        sorter: (a, b) => alphanumericSort(a, b, "imeiNumber"),
        width: 100,
      },

      {
        title: "Sim Id",
        dataIndex: "simId",
        sorter: (a, b) => alphanumericSort(a, b, "simId"),
        width: 100,
      },
      {
        title: "Battery ID",
        dataIndex: "batteryId",
        sorter: (a, b) => alphanumericSort(a, b, "batteryId"),
        width: 120,
      },
      {
        title: "simActive",
        dataIndex: "simStatus",
        sorter: (a, b) => alphanumericSort(a, b, "simStatus"),
        width: 100,
      },
      {
        title: "isActive",
        dataIndex: "isActive",
        width: 100,
      },
      {
        title: "QR Code",
        dataIndex: "qrcode",
        render: RenderQrButton,
        width: 130,
      },
      {
        title: "Edit",
        dataIndex: "editTableRow",
        render: RenderEditButton,
        width: 100,
      },

      {
        title: "Action",
        dataIndex: "deleteTableRow",
        render: RenderDeleteButton,
        width: 130,
      },
    ],
    MANUFACTURER_DEVICE_2: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 100,
      },

      {
        title: "Device Type",
        dataIndex: "deviceTypeId",
        filters: [
          {
            id: "FlufFit 1",
            label: "FlufFit 1",
            text: "FlufFit 1",
            value: "1",
          },
          {
            id: "FlufFit 2",
            label: "FlufFit 2",
            text: "FlufFit 2",
            value: "2",
          },
        ],
        filterMultiple: false,
        onFilter: (value, record) => true,
        filterSearch: true,
        width: 130,
      },

      {
        title: "Device Id",
        dataIndex: "DID_D",
        sorter: (a, b) => alphanumericSort(a, b, "DID"),
        width: 150,
      },
      {
        title: "PCB Id",
        dataIndex: "pcbId",
        sorter: (a, b) => alphanumericSort(a, b, "pcbId"),
        width: 100,
      },
      {
        title: "IMEI Number",
        dataIndex: "imeiNumber",
        sorter: (a, b) => alphanumericSort(a, b, "imeiNumber"),
        width: 100,
      },

      {
        title: "Sim Id",
        dataIndex: "simId",
        sorter: (a, b) => alphanumericSort(a, b, "simId"),
        width: 100,
      },
      {
        title: "Battery ID",
        dataIndex: "batteryId",
        sorter: (a, b) => alphanumericSort(a, b, "batteryId"),
        width: 120,
      },

      {
        title: "QR Code",
        dataIndex: "qrcode",
        render: RenderQrButton,
        width: 130,
      },
      {
        title: "Edit",
        dataIndex: "editTableRow",
        render: RenderEditButton,
        width: 100,
      },
    ],

    DEVICE_ERROR_LOG: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 70,
      },

      {
        title: "Error Code",
        dataIndex: "errorCode",
        sorter: (a, b) => alphanumericSort(a, b, "errorCode"),
        width: 60,
      },
      {
        title: "Unique Id",
        dataIndex: "uniqueIdD",
        width: 120,
      },
      {
        title: "Timestamp",
        dataIndex: "timeStampD",
        width: 80,
      },
      {
        title: "Message",
        dataIndex: "message",
        sorter: (a, b) => alphanumericSort(a, b, "message"),
        width: 120,
      },
    ],
    PET_DEVICE_ERROR_LOG: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 70,
      },

      {
        title: "Error Code",
        dataIndex: "errorCode",
        sorter: (a, b) => alphanumericSort(a, b, "errorCode"),
        width: 100,
      },
      {
        title: "Unique Id",
        dataIndex: "uniqueIdD",
        width: 120,
      },
      {
        title: "Timestamp",
        dataIndex: "timeStampD",
        width: 80,
      },
      {
        title: "Message",
        dataIndex: "message",
        sorter: (a, b) => alphanumericSort(a, b, "message"),
        width: 180,
      },
      {
        title: "Remark",
        dataIndex: "remark",
        sorter: (a, b) => alphanumericSort(a, b, "message"),
        width: 180,
      },
      {
        title: "Edit",
        dataIndex: "editTableRow",
        render: RenderEditButton,
        width: 50,
      },
    ],

    PLAN: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 80,
      },
      {
        title: "View",
        dataIndex: "view",
        render: RenderViewButton,
        width: 50,
      },

      {
        title: "Plan Name",
        dataIndex: "name",
        sorter: (a, b) => alphanumericSort(a, b, "name"),
        width: 90,
      },
      {
        title: "Features",
        dataIndex: "feature",
        sorter: (a, b) => alphanumericSort(a, b, "feature"),
        width: 110,
      },

      {
        title: "Accessible Device",
        dataIndex: "accessibleDevice",
        sorter: (a, b) => alphanumericSort(a, b, "accessibleDevice"),
        width: 130,
      },
    ],
    SUB_PLAN: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 80,
      },

      {
        title: "Plan Name",
        dataIndex: "name",
        sorter: (a, b) => alphanumericSort(a, b, "name"),
        width: 90,
      },
      {
        title: "Price (₹)",
        dataIndex: "price",
        sorter: (a, b) => alphanumericSort(a, b, "price"),
        width: 100,
      },
      {
        title: "Duration (Months)",
        dataIndex: "duration",
        sorter: (a, b) => alphanumericSort(a, b, "duration"),
        width: 100,
      },
      {
        title: "Offer Price (₹)",
        dataIndex: "offerPrice",
        sorter: (a, b) => alphanumericSort(a, b, "offerPrice"),
        width: 100,
      },

      {
        title: "Edit",
        dataIndex: "editTableRow",
        render: RenderEditButton,
        width: 100,
      },
      {
        title: "Action",
        dataIndex: "deleteTableRow",
        render: RenderDeleteButton,
        width: 100,
      },
    ],
    ADMIN_FEEDER_LIST: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 100,
      },
      {
        title: "View",
        dataIndex: "view",
        render: RenderViewButton,
        width: 100,
      },

      {
        title: "DID",
        dataIndex: "DID_D",
        sorter: (a, b) => alphanumericSort(a, b, "DID"),
        width: 220,
      },
      {
        title: "Unique Id",
        dataIndex: "uniqueIdD",
        sorter: (a, b) => alphanumericSort(a, b, "uniqueId"),
        width: 220,
      },
      {
        title: "Version",
        dataIndex: "firmwareVersion",
        sorter: (a, b) => alphanumericSort(a, b, "firmwareVersion"),
        width: 100,
      },
      {
        title: "PCB Id",
        dataIndex: "pcbId",
        sorter: (a, b) => alphanumericSort(a, b, "pcbId"),
        width: 130,
      },
      {
        title: "Battery ID",
        dataIndex: "batteryId",
        sorter: (a, b) => alphanumericSort(a, b, "batteryId"),
        width: 130,
      },
      {
        title: "isActive",
        dataIndex: "isActive",
        width: 120,
      },
      {
        title: "QR Code",
        dataIndex: "qrcode",
        render: RenderQrButton,
        width: 160,
      },
      {
        title: "Edit",
        dataIndex: "editTableRow",
        render: RenderEditButton,
        width: 100,
      },

      {
        title: "Action",
        dataIndex: "deleteTableRow",
        render: RenderDeleteButton,
        width: 100,
      },
    ],
    FEEDER_LIST: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 100,
      },
      {
        title: "View",
        dataIndex: "view",
        render: RenderViewButton,
        width: 100,
      },

      {
        title: "DID",
        dataIndex: "DID_D",
        sorter: (a, b) => alphanumericSort(a, b, "DID"),
        width: 220,
      },
      {
        title: "Unique Id",
        dataIndex: "uniqueIdD",
        sorter: (a, b) => alphanumericSort(a, b, "uniqueId"),
        width: 220,
      },
      {
        title: "Version",
        dataIndex: "firmwareVersion",
        sorter: (a, b) => alphanumericSort(a, b, "firmwareVersion"),
        width: 100,
      },
      {
        title: "PCB Id",
        dataIndex: "pcbId",
        sorter: (a, b) => alphanumericSort(a, b, "pcbId"),
        width: 130,
      },
      {
        title: "Battery ID",
        dataIndex: "batteryId",
        sorter: (a, b) => alphanumericSort(a, b, "batteryId"),
        width: 130,
      },
      {
        title: "isActive",
        dataIndex: "isActive",
        width: 120,
      },
      {
        title: "QR Code",
        dataIndex: "qrcode",
        render: RenderQrButton,
        width: 160,
      },
      {
        title: "Edit",
        dataIndex: "editTableRow",
        render: RenderEditButton,
        width: 100,
      },


    ],

    PET_LOCATION_HISTORY_LIST: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 100,
      },

      {
        title: "Date & Time",
        dataIndex: "date",
        width: 120,
      },

      {
        title: "Role",
        dataIndex: "role",
        width: 80,
      },
      {
        title: "Name",
        dataIndex: "name",
        width: 80,
      },
      {
        title: "Email",
        dataIndex: "email",
        width: 100,
      },
      {
        title: "Device Id",
        dataIndex: "deviceId",
        width: 100,
      },

      {
        title: "Reason",
        dataIndex: "reason",
        width: 150,
      },
    ],
    LOCATION_HISTORY_LIST: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 100,
      },

      {
        title: "Admin Name",
        dataIndex: "admin",
        width: 90,
      },
      {
        title: "User Name",
        dataIndex: "userName",
        width: 80,
      },
      {
        title: "Pet Name",
        dataIndex: "pet",
        width: 80,
      },

      {
        title: "Device ID",
        dataIndex: "deviceId",
        width: 100,
      },
      {
        title: "Date & Time",
        dataIndex: "date",
        width: 150,
      },
      {
        title: "Reason",
        dataIndex: "reason",
        width: 150,
      },
    ],
    MEDICINE_LIST: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 100,
      },

      {
        title: "Company Name",
        dataIndex: "companyName",
        sorter: (a, b) => alphanumericSort(a, b, "companyName"),
        width: 100,
      },
      {
        title: "Medicine Name",
        dataIndex: "medicineName",
        sorter: (a, b) => alphanumericSort(a, b, "medicineName"),
        width: 100,
      },
      {
        title: "Medicine Composition",
        dataIndex: "medicineComposition",
        sorter: (a, b) => alphanumericSort(a, b, "medicineComposition"),
        width: 130,
      },

      {
        title: "Other Info",
        dataIndex: "otherInfo",
        sorter: (a, b) => alphanumericSort(a, b, "otherInfo"),
        width: 80,
      },
      {
        title: "Edit",
        dataIndex: "editTableRow",
        render: RenderEditButton,
        width: 80,
      },
      {
        title: "Action",
        dataIndex: "deleteTableRow",
        render: RenderDeleteButton,
        width: 80,
      },

    ],
    FOOD_CALORIES_LIST: [
      {
        title: "No.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 115,
      },

      {
        title: "Food Type",
        dataIndex: "foodType",
        sorter: (a, b) => alphanumericSort(a, b, "foodType"),
        width: 120,
      },
      {
        title: "Product Name",
        dataIndex: "productName",
        sorter: (a, b) => alphanumericSort(a, b, "productName"),
        width: 140,
      },
      {
        title: "Brand Name",
        dataIndex: "brandName",
        sorter: (a, b) => alphanumericSort(a, b, "brandName"),
        width: 130,
      },
      {
        title: "Dog Size",
        dataIndex: "dogSize",
        sorter: (a, b) => alphanumericSort(a, b, "dogSize"),
        width: 120,
      },
      {
        title: "Lower Weight (Kg)",
        dataIndex: "lowerWeightInKg",
        sorter: (a, b) => alphanumericSort(a, b, "lowerWeightInKg"),
        width: 130,
      },
      {
        title: "Upper Weight (Kg)",
        dataIndex: "upperWeightInKg",
        sorter: (a, b) => alphanumericSort(a, b, "upperWeightInKg"),
        width: 130,
      },

      {
        title: "Min Age in Month",
        dataIndex: "minAgeInMonth",
        sorter: (a, b) => alphanumericSort(a, b, "minAgeInMonth"),
        width: 130,
      },
      {
        title: "Max Age in Month",
        dataIndex: "maxAgeInMonth",
        sorter: (a, b) => alphanumericSort(a, b, "maxAgeInMonth"),
        width: 130,
      },
      {
        title: "Min Quantity In Grams",
        dataIndex: "minQuantityInGrams",
        sorter: (a, b) => alphanumericSort(a, b, "minQuantityInGrams"),
        width: 140,
      },
      {
        title: "Max Quantity In Grams",
        dataIndex: "maxQuantityInGrams",
        sorter: (a, b) => alphanumericSort(a, b, "maxQuantityInGrams"),
        width: 140,
      },
      {
        title: "Kilo Calories per 100 Grams",
        dataIndex: "kcalPer100Grams",
        sorter: (a, b) => alphanumericSort(a, b, "kcalPer100Grams"),
        width: 150,
      },
      {
        title: "Kibble Size",
        dataIndex: "kibbleSize",
        sorter: (a, b) => alphanumericSort(a, b, "kibbleSize"),
        width: 130,
      },
      {
        title: "Activity Level",
        dataIndex: "activityLevel",
        sorter: (a, b) => alphanumericSort(a, b, "activityLevel"),
        width: 140,
      },
      {
        title: "Last Updated Time",
        dataIndex: "updateTime",
        sorter: (a, b) => alphanumericSort(a, b, "updatedAt"),
        width: 140,
      },
      {
        title: "Edit",
        dataIndex: "editTableRow",
        render: RenderEditButton,
        width: 80,
      },
      {
        title: "Action",
        dataIndex: "deleteTableRow",
        render: RenderDeleteButton,
        width: 80,
      },

    ],
  },
  FORM_FIELD: {
    LOGIN_PAGE_MODAL: [
      {
        no: 1,
        // Label: "User Name",
        name: "name",
        id: "name",
        type: "text",
        placeholder: "User name",
        required: true,
        width: 24,
      },
      {
        no: 1,
        // Label: "Password",
        name: "password",
        width: 24,
        id: "password",
        type: "password",
        placeholder: "Password",
        required: true,
      },
    ],
    USERS_MODAL: [
      {
        no: 1,
        Label: "Name",
        name: "name",
        id: "name",
        type: "text",
        placeholder: "Enter Your Name",
        required: true,
        labelwidth: 5,
      },

      {
        no: 2,
        Label: "Mobile Number",
        name: "mobile",
        id: "mobile",
        type: "mobile",
        placeholder: "Enter Mobile Number",
        required: true,
        labelwidth: 5,
        // width: 20,
      },
      {
        no: 3,
        Label: "Username",
        name: "user",
        id: "user",
        type: "text",
        placeholder: "Enter User Name",
        // required: true,
        labelwidth: 8,
        width: 8,
      },

      {
        no: 4,
        Label: "Date of Birth",
        name: "date",
        id: "date",
        type: "date",
        placeholder: "Enter Date of Birth",
        required: true,
        labelwidth: 8,
        width: 8,
      },
      {
        no: 5,
        Label: "Profile Picture",
        name: "profilePic",
        id: "profilePic",
        type: "file",
        placeholder: " ",
        required: true,
        labelwidth: 8,
        width: 8,
      },
    ],
    TECHNOLOGY_MODAL: [
      {
        no: 1,
        Label: "Name",
        name: "name",
        id: "name",
        type: "text",
        placeholder: "Enter Your Name",
        required: true,
      },
      {
        no: 1,
        Label: "Price",
        name: "price",
        id: "price",
        type: "number",
        placeholder: "Enter Your price",
        required: true,
      },
    ],
    NOTIFICATION_MODAL: [
      {
        no: 1,
        Label: "Notification Type",
        name: "type",
        id: "type",
        type: "select",
        placeholder: "Select a Notification Type",
        required: true,
        option: [
          {
            label: "General ",
            value: "General ",
          },
          {
            label: "Reminder",
            value: "Reminder",
          },
        ],
        width: 24,
        labelwidth: 24,
      },
      {
        no: 2,
        Label: "Notification Title",
        name: "notification",
        id: "notification",
        type: "text",
        placeholder: "Enter Notification Title",
        required: true,
        width: 24,
        labelwidth: 24,
      },

      {
        no: 3,
        Label: "Message",
        name: "body",
        id: "body",
        type: "text",
        placeholder: "Enter Message",
        required: true,
        width: 24,
        labelwidth: 24,
      },
      {
        no: 4,
        Label: "Click Action",
        name: "clickAction",
        id: "clickAction",
        type: "select",
        placeholder: "Select a Click Action",
        required: true,
        option: [
          {
            label: "Home",
            value: "Home",
          },
          {
            label: "Profile",
            value: "Profile",
          },
          {
            label: "Subscription",
            value: "Subscription",
          },
          {
            label: "Feedback",
            value: "Feedback",
          },
          {
            label: "Blog",
            value: "Blog",
          },
        ],
        width: 24,
        labelwidth: 24,
      },
    ],
    BENCHMARK_MODAL: [
      {
        no: 1,
        Label: "Breed",
        name: "breed",
        id: "breed",
        type: "text",
        placeholder: "Enter Breed",
        required: true,
        width: 12,
        labelwidth: 24,
      },

      {
        no: 2,
        Label: "Size",
        name: "size",
        id: "size",
        type: "select",
        placeholder: "Select a Size",
        required: true,
        option: [
          {
            label: "Small",
            value: "Small",
          },
          {
            label: "Medium",
            value: "Medium",
          },
          {
            label: "Large",
            value: "Large",
          },
        ],
        width: 12,
        labelwidth: 24,
      },
      {
        no: 3,
        Label: "Female Lower Weight (kg)",
        name: "lowerWeightFemale",
        id: "lowerWeightFemale",
        type: "number",
        placeholder: "Enter Female Lower Weight",
        required: true,
        width: 12,
        labelwidth: 24,
      },
      {
        no: 4,
        Label: "Female Higher Weight (kg)",
        name: "heigherWeightFemale",
        id: "heigherWeightFemale",
        type: "number",
        placeholder: "Enter Female Higher Weight",
        required: true,
        width: 12,
        labelwidth: 24,
      },
      {
        no: 5,
        Label: "Male Lower Weight (kg)",
        name: "lowerWeightMale",
        id: "lowerWeightMale",
        type: "number",
        placeholder: "Enter Male Lower Weight",
        required: true,
        width: 12,
        labelwidth: 24,
      },
      {
        no: 6,
        Label: "Male Higher Weight (kg)",
        name: "heigherWeightMale",
        id: "heigherWeightMale",
        type: "number",
        placeholder: "Enter Male Higher Weight",
        required: true,
        width: 12,
        labelwidth: 24,
      },
    ],
    BENCHMARK_ACTIVITY_MODAL: [
      {
        no: 1,
        Label: "Start Age",
        name: "startAge",
        id: "startAge",
        type: "number",
        placeholder: "Enter Start Age",
        required: true,
        width: 12,
        labelwidth: 24,
      },
      {
        no: 2,
        Label: "End Age",
        name: "endAge",
        id: "endAge",
        type: "number",
        placeholder: "Enter End Age",
        required: true,
        width: 12,
        labelwidth: 24,
      },

      {
        no: 3,
        Label: "Walk Time",
        name: "walkTime",
        id: "walkTime",
        type: "number",
        placeholder: "Enter Walk Time",
        required: true,
        width: 12,
        labelwidth: 24,
      },
      {
        no: 4,
        Label: "Play Time",
        name: "playTime",
        id: "playTime",
        type: "number",
        placeholder: "Enter Play Time",
        required: true,
        width: 12,
        labelwidth: 24,
      },
      {
        no: 5,
        Label: "Sleep Time",
        name: "sleepTime",
        id: "sleepTime",
        type: "number",
        placeholder: "Enter Sleep Time",
        required: true,
        width: 12,
        labelwidth: 24,
      },
      {
        no: 6,
        Label: "Rest Time",
        name: "restTime",
        id: "restTime",
        type: "number",
        placeholder: "Rest Time",
        required: true,
        width: 12,
        labelwidth: 24,
      },
    ],
    SUB_PLAN_MODAL: [
      {
        no: 1,
        Label: "Plan Name",
        name: "name",
        id: "name",
        type: "text",
        placeholder: "Enter Plan Name",
        required: true,
        width: 12,
        labelwidth: 24,
      },
      {
        no: 2,
        Label: "Price (₹)",
        name: "price",
        id: "price",
        type: "number",
        placeholder: "Enter Price (₹)",
        required: true,
        width: 12,
        labelwidth: 24,
      },

      {
        no: 3,
        Label: "Duration (Months)",
        name: "duration",
        id: "duration",
        type: "number",
        placeholder: "Enter Duration (Months)",
        required: true,
        width: 12,
        labelwidth: 24,
      },
      {
        no: 4,
        Label: "Offer Price (₹)",
        name: "offerPrice",
        id: "offerPrice",
        type: "number",
        placeholder: "Enter Offer Price (₹)",
        required: true,
        width: 12,
        labelwidth: 24,
      },
    ],
    DEVICE_MODAL: [
      {
        no: 1,
        Label: "Sim Id",
        name: "simId",
        id: "simId",
        type: "text",
        placeholder: "Enter Sim Id",
        required: true,
        width: 24,
        labelwidth: 24,
      },
    ],
    MODE_FEEDBACK_MODAL: [
      {
        no: 0,
        Label: "Question",
        name: "question",
        id: "question",
        type: "text",
        placeholder: "Enter a Question",
        required: true,
        width: 24,
        labelwidth: 24,
      },

      {
        no: 1,
        Label: "Options",
        name: "options",
        id: "options",
        type: "option",
        placeholder: "Enter a options",
        required: true,
        width: 12,
        labelwidth: 24,
      },
      {
        no: 5,
        Label: "Mode",
        name: "mode",
        id: "mode",
        type: "select",
        placeholder: "Select a Mode",
        width: 12,
        labelwidth: 24,
        option: [
          // {
          //   id: 1,
          //   Label: 'SOS Mode',
          //   value: 0,
          // },
          // {
          //   id: 2,
          //   Label: 'Normal or Default Mode',
          //   value: 1,
          // },
          {
            id: 3,
            Label: "Walk Mode",
            value: 2,
          },
          {
            id: 4,
            Label: "Boarding Mode",
            value: 3,
          },
          {
            id: 4,
            Label: "Super Saver Mode",
            value: 4,
          },
        ],

        required: true,
      },
    ],
    ROLE_ACCESS_MODAL: [
      {
        no: 0,
        Label: "Name",
        name: "name",
        id: "name",
        type: "text",
        placeholder: "Enter a Name",
        required: true,
        width: 24,
        labelwidth: 24,
      },

      {
        no: 1,
        Label: "Email",
        name: "email",
        id: "email",
        type: "email",
        placeholder: "Enter a Email",
        required: true,
        width: 12,
        labelwidth: 24,
      },
      {
        no: 2,
        Label: "Password",
        name: "password",
        id: "password",
        type: "password",
        placeholder: "Enter a Password",
        required: true,
        width: 12,
        labelwidth: 24,
      },
      {
        no: 3,
        Label: "Mobile",
        name: "mobile",
        id: "mobile",
        type: "mobile",
        placeholder: "Enter a Mobile",
        required: true,
        width: 12,
        labelwidth: 24,
      },
      {
        no: 4,
        Label: "Role",
        name: "role",
        id: "role",
        type: "select",
        placeholder: "Select a Role",
        width: 12,
        labelwidth: 24,
        option: [
          {
            id: 1,
            Label: "Admin",
            value: "Admin",
          },
          {
            id: 2,
            Label: "Client Support",
            value: "ClientSupport",
          },
          {
            id: 3,
            Label: "Manufacturer",
            value: "Manufacturer",
          },
        ],

        required: true,
      },
    ],
    EDIT_ROLE_ACCESS_MODAL: [
      {
        no: 0,
        Label: "Name",
        name: "name",
        id: "name",
        type: "text",
        placeholder: "Enter a Name",
        required: true,
        width: 12,
        labelwidth: 24,
      },

      {
        no: 1,
        Label: "Email",
        name: "email",
        id: "email",
        type: "email",
        placeholder: "Enter a Email",
        required: true,
        width: 12,
        labelwidth: 24,
      },

      {
        no: 3,
        Label: "Mobile",
        name: "mobile",
        id: "mobile",
        type: "mobile",
        placeholder: "Enter a Mobile",
        required: true,
        width: 12,
        labelwidth: 24,
      },
      {
        no: 4,
        Label: "Role",
        name: "role",
        id: "role",
        type: "select",
        placeholder: "Select a Role",
        width: 12,
        labelwidth: 24,
        option: [
          {
            id: 1,
            Label: "Admin",
            value: "Admin",
          },
          {
            id: 2,
            Label: "Client Support",
            value: "ClientSupport",
          },
          {
            id: 3,
            Label: "Manufacturer",
            value: "Manufacturer",
          },
        ],

        required: true,
      },
    ],
    DEVICES_MODAL: [
      {
        no: 0,
        Label: "Animal Type",
        name: "animalType",
        id: "animalType",
        disabled: true,
        type: "text",
        defaultValue: "Dog",
        placeholder: "Enter a Animal Type",
        required: true,
        width: 12,
        labelwidth: 24,
      },
      {
        no: 1,
        Label: "Version",
        name: "firmwareVersion",
        id: "firmwareVersion",
        disabled: true,
        type: "text",
        defaultValue: "1",
        placeholder: "Enter a Version",
        required: true,
        width: 12,
        labelwidth: 24,
      },

      {
        no: 2,
        Label: "Color of Pod",
        name: "colorOfPod",
        id: "colorOfPod",
        type: "select",
        placeholder: "Select a Color of Pod",
        required: true,
        width: 12,
        labelwidth: 24,
        option: [
          {
            id: 1,
            Label: "Black",
            value: "black",
          },
          {
            id: 2,
            Label: "White",
            value: "white",
          },
        ],
      },
      {
        no: 3,
        Label: "PCB ID",
        name: "pcbId",
        id: "pcbId",
        type: "text",
        placeholder: "Enter a PCB ID",
        required: true,
        width: 12,
        labelwidth: 24,
      },
      {
        no: 4,
        Label: "IMEI Number",
        name: "imeiNumber",
        id: "imeiNumber",
        type: "text",
        placeholder: "Enter a IMEI Number",
        required: true,
        width: 12,
        labelwidth: 24,
      },
      {
        no: 5,
        Label: "Sim ID",
        name: "simId",
        id: "simId",
        type: "text",
        placeholder: "Enter a Sim ID",
        required: true,
        width: 12,
        labelwidth: 24,
      },
      {
        no: 6,
        Label: "Battery ID",
        name: "batteryId",
        id: "batteryId",
        type: "text",
        placeholder: "Enter a Battery ID",
        required: true,
        width: 12,
        labelwidth: 24,
      },
      {
        no: 7,
        Label: "Device Type",
        name: "deviceTypeId",
        id: "deviceTypeId",
        type: "select",
        placeholder: "Select a Device Type",
        width: 12,
        labelwidth: 24,
        option: [
          {
            id: 1,
            Label: "FlufFit 1",
            value: 1,
          },
          {
            id: 2,
            Label: "FlufFit 2",
            value: 2,
          },
        ],

        required: true,
      },
    ],
    EDIT_DEVICES_MODAL: [
      {
        no: 3,
        Label: "PCB ID",
        name: "pcbId",
        id: "pcbId",
        type: "text",
        placeholder: "Enter a PCB ID",
        required: true,
        width: 12,
        labelwidth: 24,
      },
      {
        no: 4,
        Label: "IMEI Number",
        name: "imeiNumber",
        id: "imeiNumber",
        type: "text",
        placeholder: "Enter a IMEI Number",
        required: true,
        width: 12,
        labelwidth: 24,
      },
      {
        no: 5,
        Label: "Sim ID",
        name: "simId",
        id: "simId",
        type: "text",
        placeholder: "Enter a Sim ID",
        required: true,
        width: 12,
        labelwidth: 24,
      },
      {
        no: 6,
        Label: "Battery ID",
        name: "batteryId",
        id: "batteryId",
        type: "text",
        placeholder: "Enter a Battery ID",
        required: true,
        width: 12,
        labelwidth: 24,
      },
    ],
    LOCATION_MODAL: [
      {
        no: 0,
        Label: "Password",
        name: "password",
        id: "password",
        type: "password",
        placeholder: "Enter a Password Type",
        required: true,
        width: 24,
        labelwidth: 24,
      },

      {
        no: 1,
        Label: "Reason",
        name: "reason",
        id: "reason",
        type: "reason",
        placeholder: "Enter a Reason",
        required: true,
        width: 24,
        labelwidth: 24,
      },
    ],
    ERROR_LOG_MODAL: [
      {
        no: 1,
        Label: "Remark",
        name: "remark",
        id: "remark",
        type: "remark",
        placeholder: "Enter a Remark",
        required: true,
        width: 24,
        labelwidth: 24,
      },
    ],
    BANNER_MODAL: [
      {
        no: 0,
        Label: "Name",
        name: "name",
        id: "name",
        type: "text",
        placeholder: "Enter a Name",
        required: false,
        labelwidth: 12,
      },
      {
        no: 1,
        Label: "Flag",
        name: "allFlag",
        id: "allFlag",
        type: "select",
        placeholder: "Select Flags",
        option: [
          {
            id: 1,
            Label: "Without Device",
            value: "withoutDevice",
          },
          {
            id: 2,
            Label: "With Device",
            value: "withDevice",
          },
          {
            id: 3,
            Label: "Without Feeder",
            value: "withoutFeeder",
          },
          {
            id: 4,
            Label: "With Feeder",
            value: "withFeeder",
          },
          {
            id: 5,
            Label: "General",
            value: "general",
          },
          {
            id: 6,
            Label: "Premium User",
            value: "premiumUser",
          },
          {
            id: 7,
            Label: "Sub Premium User",
            value: "subPremiumUser",
          },
        ],
        mode: "multiple",
        required: true,
        labelwidth: 12,
      },

      {
        no: 2,
        Label: "Redirection Link",
        name: "redirectionLink",
        id: "redirectionLink",
        type: "url",
        placeholder: "Enter Redirection Link",
        required: false,
        labelwidth: 12,
        // width: 8,
      },

      {
        no: 3,
        Label: "Image",
        name: "image",
        id: "image",
        type: "file",
        placeholder: " ",
        required: true,
        // labelwidth: 24,
        // width: 8,
      },
    ],
    EDIT_BANNER_MODAL: [

      {
        no: 0,
        Label: "Name",
        name: "name",
        id: "name",
        type: "text",
        placeholder: "Enter a Name",
        required: false,
        labelwidth: 12,
      },
      {
        no: 1,
        Label: "Flag",
        name: "allFlag",
        id: "allFlag",
        type: "select",
        placeholder: "Select Flags",
        option: [
          {
            id: 1,
            Label: "Without Device",
            value: "withoutDevice",
          },
          {
            id: 2,
            Label: "With Device",
            value: "withDevice",
          },
          {
            id: 3,
            Label: "Without Feeder",
            value: "withoutFeeder",
          },
          {
            id: 4,
            Label: "With Feeder",
            value: "withFeeder",
          },
          {
            id: 5,
            Label: "General",
            value: "general",
          },
          {
            id: 6,
            Label: "Premium User",
            value: "premiumUser",
          },
          {
            id: 7,
            Label: "Sub Premium User",
            value: "subPremiumUser",
          },
        ],
        mode: "multiple",
        required: true,
        labelwidth: 12,
      },
      {
        no: 2,
        Label: "Redirection Link",
        name: "redirectionLink",
        id: "redirectionLink",
        type: "url",
        placeholder: "Enter Redirection Link",
        required: false,
        labelwidth: 12,
        // width: 8,
      },

      {
        no: 3,
        Label: "Image",
        name: "image",
        id: "image",
        type: "file",
        placeholder: " ",
        required: false,
        // labelwidth: 24,
        // width: 8,
      },
    ],
    MEDICINE_MODAL: [
      {
        no: 0,
        Label: "Company Name",
        name: "companyName",
        id: "companyName",
        type: "text",
        placeholder: "Enter a Company Name",
        required: true,
        labelwidth: 12,
        width: 12,
      },
      {
        no: 1,
        Label: "Medicine Name",
        name: "medicineName",
        id: "medicineName",
        type: "text",
        placeholder: "Enter a Medicine Name",
        required: true,
        labelwidth: 12,
        width: 12,
      },
      {
        no: 2,
        Label: "Medicine Composition",
        name: "medicineComposition",
        id: "medicineComposition",
        type: "text",
        placeholder: "Enter a Medicine Composition",
        required: false,
        labelwidth: 12,
        width: 12,
      },
      {
        no: 3,
        Label: "Other Info",
        name: "otherInfo",
        id: "otherInfo",
        type: "text",
        placeholder: "Enter a Other Info",
        required: false,
        labelwidth: 12,
        width: 12,
      },

    ],
    FOOD_CALORIES_MODAL: [
      {
        no: 0,
        Label: "Food Type",
        name: "foodType",
        id: "foodType",
        type: "select",
        placeholder: "Select a Food Type",
        option: [

          {
            id: 1,
            Label: "Dry Food",
            value: "Dry Food",
          },
          {
            id: 2,
            Label: "Wet Food",
            value: "Wet Food",
          },
          {
            id: 3,
            Label: "Other",
            value: "Other",
          },

        ],
        required: true,
        labelwidth: 12,
        width: 12,
      },
      {
        no: 1,
        Label: "Brand Name",
        name: "brandName",
        id: "brandName",
        type: "text",
        placeholder: "Enter a Brand Name",
        required: true,
        labelwidth: 12,
        width: 12,
      },
      {
        no: 2,
        Label: "Product Name",
        name: "productName",
        id: "productName",
        type: "text",
        placeholder: "Enter a Product Name",
        required: true,
        labelwidth: 12,
        width: 12,
      },
      {
        no: 3,
        Label: "Dog Size",
        name: "dogSize",
        id: "dogSize",
        type: "select",
        placeholder: "Select a Dog Size",
        width: 12,
        labelwidth: 24,
        option: [
          {
            id: 0,
            Label: "None",
            value: null,
          },
          {
            id: 1,
            Label: "Small",
            value: "Small",
          },
          {
            id: 2,
            Label: "Medium",
            value: "Medium",
          },
          {
            id: 3,
            Label: "Large",
            value: "Large",
          },
          {
            id: 4,
            Label: "Giant",
            value: "Giant",
          },

        ],

        required: false,
      },
      {
        no: 4,
        Label: "Min Age Month",
        name: "minAgeInMonth",
        id: "minAgeInMonth",
        type: "number",
        placeholder: "Enter a Min Age Month",
        required: true,
        labelwidth: 12,
        width: 12,
      },
      {
        no: 5,
        Label: "Max Age Month",
        name: "maxAgeInMonth",
        id: "maxAgeInMonth",
        type: "number",
        placeholder: "Enter a Max Age Month",
        required: true,
        labelwidth: 12,
        width: 12,
      },
      {
        no: 6,
        Label: "Lower Weight (Kg)",
        name: "lowerWeightInKg",
        id: "lowerWeightInKg",
        type: "number",
        placeholder: "Enter a Lower Weight (Kg)",
        required: false,
        labelwidth: 12,
        width: 12,
      },
      {
        no: 7,
        Label: "Upper Weight (Kg)",
        name: "upperWeightInKg",
        id: "upperWeightInKg",
        type: "number",
        placeholder: "Enter a Upper Weight",
        required: false,
        labelwidth: 12,
        width: 12,
      },
      {
        no: 8,
        Label: "Min Quantity in Grams",
        name: "minQuantityInGrams",
        id: "minQuantityInGrams",
        type: "number",
        placeholder: "Enter a Min Quantity in Grams",
        required: true,
        labelwidth: 12,
        width: 12,
      },
      {
        no: 9,
        Label: "Max Quantity in Grams",
        name: "maxQuantityInGrams",
        id: "maxQuantityInGrams",
        type: "number",
        placeholder: "Enter a Max Quantity in Grams",
        required: true,
        labelwidth: 12,
        width: 12,
      },
      {
        no: 10,
        Label: "Kilo Calories Per 100 Grams",
        name: "kcalPer100Grams",
        id: "kcalPer100Grams",
        type: "number",
        placeholder: "Enter a Kilo Calories Per 100 Grams",
        required: true,
        labelwidth: 12,
        width: 12,
      },
      {
        no: 11,
        Label: "Kibble Size",
        name: "kibbleSize",
        id: "kibbleSize",
        type: "text",
        placeholder: "Enter a Kibble Size",
        required: false,
        labelwidth: 12,
        width: 12,
      },
      {
        no: 12,
        Label: "Activity Level",
        name: "activityLevel",
        id: "activityLevel",
        type: "select",
        placeholder: "Select a Activity Level",
        width: 12,
        labelwidth: 24,
        option: [
          {
            id: 0,
            Label: "None",
            value: null,
          },
          {
            id: 1,
            Label: "Low",
            value: "Low",
          },
          {
            id: 2,
            Label: "Medium",
            value: "Medium",
          },
          {
            id: 3,
            Label: "High",
            value: "High",
          },

        ],

        required: false,
      },

    ],
    FEEDER_MODAL: [
      {
        no: 0,
        Label: "Animal Type",
        name: "animalType",
        id: "animalType",
        type: "select",
        placeholder: "Select a Animal Type",
        option: [
          {
            id: 0,
            Label: "Dog",
            value: "D",
          },
          {
            id: 1,
            Label: "Cat",
            value: "C",
          },


        ],
        required: true,
        width: 12,
        labelwidth: 24,
      },
      {
        no: 1,
        Label: "Device Type",
        name: "deviceType",
        id: "deviceType",
        type: "select",
        placeholder: "Select a Device Type",
        option: [
          {
            id: 0,
            Label: "Dry",
            value: "dry",
          },
          {
            id: 1,
            Label: "Wet",
            value: "wet",
          },


        ],
        required: true,
        width: 12,
        labelwidth: 24,
      },
      {
        no: 3,
        Label: "Version",
        name: "firmwareVersion",
        id: "firmwareVersion",
        // disabled: true,
        type: "integer",
        // defaultValue: "1",
        placeholder: "Enter a Version",
        required: true,
        width: 12,
        labelwidth: 24,
      },

      {
        no: 4,
        Label: "Color of Pod",
        name: "colorOfPod",
        id: "colorOfPod",
        type: "select",
        placeholder: "Select a Color of Pod",
        required: true,
        width: 12,
        labelwidth: 24,
        option: [
          {
            id: 1,
            Label: "Black",
            value: "black",
          },
          {
            id: 2,
            Label: "White",
            value: "white",
          },
        ],
      },
      {
        no: 5,
        Label: "PCB ID",
        name: "pcbId",
        id: "pcbId",
        type: "text",
        placeholder: "Enter a PCB ID",
        required: true,
        width: 12,
        labelwidth: 24,
      },

      {
        no: 6,
        Label: "Battery ID",
        name: "batteryId",
        id: "batteryId",
        type: "text",
        placeholder: "Enter a Battery ID",
        required: true,
        width: 12,
        labelwidth: 24,
      },

    ],
    EDIT_FEEDER_MODAL: [


      {
        no: 3,
        Label: "Version",
        name: "firmwareVersion",
        id: "firmwareVersion",
        // disabled: true,
        type: "integer",
        // defaultValue: "1",
        placeholder: "Enter a Version",
        required: true,
        width: 24,
        labelwidth: 24,
      },

      {
        no: 5,
        Label: "PCB ID",
        name: "pcbId",
        id: "pcbId",
        type: "text",
        placeholder: "Enter a PCB ID",
        required: true,
        width: 12,
        labelwidth: 24,
      },

      {
        no: 6,
        Label: "Battery ID",
        name: "batteryId",
        id: "batteryId",
        type: "text",
        placeholder: "Enter a Battery ID",
        required: true,
        width: 12,
        labelwidth: 24,
      },

    ],
  },

  API: {
    login: {
      type: "POST",
      endpoint: "/admin/admin/login",
    },
    forget_password: {
      type: "POST",
      endpoint: "/admin/admin/forgotPassword",
    },
    reset_password: {
      type: "POST",
      endpoint: "/admin/admin/resetPassword",
    },

    signUp: {
      type: "POST",
      endpoint: "/user/signup",
    },

    getMe: {
      type: "GET",
      endpoint: "/admin/admin/my/profile",
    },

    // Analytics API

    Analytics: {
      getAll: {
        type: "GET",
        endpoint: "/admin/analytics",
      },
    },

    // Users API

    User: {
      getAll: {
        type: "GET",
        endpoint: "/admin/user",
      },
      getOne: {
        type: "GET",
        endpoint: "/admin/user/:id",
      },
      update: {
        type: "PATCH",
        endpoint: "/admin/user/",
      },
      notification: {
        type: "GET",
        endpoint: "/admin/notification/addPersonalNotification",
      },
    },
    // Role and Access API

    Role_Access: {
      getAll: {
        type: "GET",
        endpoint: "/admin/admin/all",
      },
      add: {
        type: "POST",
        endpoint: "/admin/admin/signup",
      },
      update: {
        type: "PATCH",
        endpoint: "/admin/admin/",
      },
      delete: {
        type: "DELETE",
        endpoint: "/admin/admin/",
      },
    },

    // Subsctiption API

    Subscription: {
      getAll: {
        type: "GET",
        endpoint: "/admin/userSubscription",
      },
    },
    // Transaction API

    Transaction: {
      getAll: {
        type: "GET",
        endpoint: "/admin/userTransaction",
      },
    },


    // Banner
    Banner: {
      getAll: {
        type: "GET",
        endpoint: "/admin/banner",
      },
      getOne: {
        type: "GET",
        endpoint: "/admin/banner/:id",
      },
      add: {
        type: "POST",
        endpoint: "/admin/banner",
      },
      update: {
        type: "PATCH",
        endpoint: "/admin/banner/:id",
      },
      delete: {
        type: "DELETE",
        endpoint: "/admin/banner/",
      },
    },
    // Pet API

    Pet: {
      getAll: {
        type: "GET",
        endpoint: "/admin/pets",
      },
      getOne: {
        type: "GET",
        endpoint: "/admin/pets/:id",
      },
      update: {
        type: "PATCH",
        endpoint: "/admin/pets/",
      },
    },

    Pet_Food_tracking: {
      getAll: {
        type: "GET",
        endpoint: "/admin/foodTracking",
      },
    },
    Pet_Weight_tracking: {
      getAll: {
        type: "GET",
        endpoint: "/admin/weightTracking",
      },
    },
    Pet_Manually_tracking: {
      getAll: {
        type: "GET",
        endpoint: "/admin/manuallyTracking",
      },
    },
    Pet_Device_Details: {
      getAll: {
        type: "GET",
        endpoint: "/admin/petDevice",
      },
    },
    Mode_History: {
      getAll: {
        type: "GET",
        endpoint: "/admin/modeHistory",
      },
    },

    // Feeder Connection API

    Feeder_Connection: {
      getAll: {
        type: "GET",
        endpoint: "/admin/feederConnect",
      },
      getOne: {
        type: "GET",
        endpoint: "/admin/feederConnect/:id",
      },
    },
    // Feeder API

    Feeder: {
      getAll: {
        type: "GET",
        endpoint: "/admin/feedar",
      },
      add: {
        type: "POST",
        endpoint: "/admin/feedar/",
      },
      update: {
        type: "PATCH",
        endpoint: "/admin/feedar/",
      },
      delete: {
        type: "DELETE",
        endpoint: "/admin/feedar/",
      },
    },
    // Feeder
    Feeder_Error: {
      getAll: {
        type: "GET",
        endpoint: "/admin/errorLogsOfFeeder",
      },
      update: {
        type: "PATCH",
        endpoint: "/admin/errorLogsOfFeeder/",
      },
    },

    // Benchmark API

    Benchmark: {
      getAll: {
        type: "GET",
        endpoint: "/admin/benchmark",
      },
      getOne: {
        type: "GET",
        endpoint: "/admin/benchmark/:id",
      },
      add: {
        type: "POST",
        endpoint: "/admin/benchmark",
      },
      update: {
        type: "PATCH",
        endpoint: "/admin/benchmark/",
      },
      delete: {
        type: "DELETE",
        endpoint: "/admin/benchmark/",
      },
    },

    // Benchmark Activity API

    BenchmarkActivity: {
      getAll: {
        type: "GET",
        endpoint: "/admin/benchmarkActivity",
      },
      getOne: {
        type: "GET",
        endpoint: "/admin/benchmarkActivity/:id",
      },
      add: {
        type: "POST",
        endpoint: "/admin/benchmarkActivity",
      },
      update: {
        type: "PATCH",
        endpoint: "/admin/benchmarkActivity/",
      },
      delete: {
        type: "DELETE",
        endpoint: "/admin/benchmarkActivity/",
      },
    },

    // Plan API

    Plan: {
      getAll: {
        type: "GET",
        endpoint: "/admin/plan",
      },
    },
    // SubPlan API

    SubPlan: {
      getAll: {
        type: "GET",
        endpoint: "/admin/subPlan",
      },
      getOne: {
        type: "GET",
        endpoint: "/admin/subPlan/:id",
      },
      add: {
        type: "POST",
        endpoint: "/admin/subPlan",
      },
      update: {
        type: "PATCH",
        endpoint: "/admin/subPlan/",
      },
      delete: {
        type: "DELETE",
        endpoint: "/admin/subPlan/",
      },
    },

    // FeedBack API

    Feedback: {
      getAll: {
        type: "GET",
        endpoint: "/admin/userFeedback",
      },
      getOne: {
        type: "GET",
        endpoint: "/admin/userFeedback/:id",
      },
    },

    // ModeFeedBack API

    Mode_Feedback: {
      getAll: {
        type: "GET",
        endpoint: "/admin/modeFeedback",
      },
      getOne: {
        type: "GET",
        endpoint: "/admin/modeFeedback/:id",
      },
      add: {
        type: "POST",
        endpoint: "/admin/modeFeedback",
      },
      update: {
        type: "PATCH",
        endpoint: "/admin/modeFeedback/",
      },
      delete: {
        type: "DELETE",
        endpoint: "/admin/modeFeedback/",
      },
    },
    Mode_User_Feedback: {
      getAll: {
        type: "GET",
        endpoint: "/admin/modeUserFeedback",
      },
    },

    // Device Type API

    DeviceType: {
      getAll: {
        type: "GET",
        endpoint: "/admin/deviceType",
      },
    },

    // Pet Device API

    Pet_Device: {
      getAll: {
        type: "GET",
        endpoint: "/admin/petDevice",
      },
      getOne: {
        type: "GET",
        endpoint: "/admin/petDevice/:id",
      },
    },
    // Location History API

    Location_history: {
      getAll: {
        type: "GET",
        endpoint: "/admin/locationHistoryAccess",
      },
      getOne: {
        type: "GET",
        endpoint: "/admin/locationHistoryAccess/:id",
      },
      verify: {
        type: "POST",
        endpoint: "/admin/locationHistoryAccess/verifyPassword/:petId",
      },
      update: {
        type: "PATCH",
        endpoint: "/admin/locationHistoryAccess/",
      },
      delete: {
        type: "DELETE",
        endpoint: "/admin/locationHistoryAccess/",
      },
    },
    // Device API

    Device: {
      getAll: {
        type: "GET",
        endpoint: "/admin/device",
      },
      getOne: {
        type: "GET",
        endpoint: "/admin/device/:id",
      },
      add: {
        type: "POST",
        endpoint: "/admin/device",
      },
      update: {
        type: "PATCH",
        endpoint: "/admin/device/",
      },
      delete: {
        type: "DELETE",
        endpoint: "/admin/device/",
      },
    },
    // Device Error API

    Device_Error: {
      getAll: {
        type: "GET",
        endpoint: "/admin/errorLogsOfCollars",
      },
      update: {
        type: "PATCH",
        endpoint: "/admin/errorLogsOfCollars/",
      },
    },

    // Medicine API

    Medicine: {
      medicine: {
        getAll: {
          type: "GET",
          endpoint: "/admin/medicineRegistry",
        },
        getOne: {
          type: "GET",
          endpoint: "/admin/medicineRegistry/:id",
        },
        add: {
          type: "POST",
          endpoint: "/admin/medicineRegistry",
        },
        update: {
          type: "PATCH",
          endpoint: "/admin/medicineRegistry/",
        },
        delete: {
          type: "DELETE",
          endpoint: "/admin/medicineRegistry/",
        },
      },
      vaccination: {
        getAll: {
          type: "GET",
          endpoint: "/admin/vaccinationRegistry",
        },
        getOne: {
          type: "GET",
          endpoint: "/admin/vaccinationRegistry/:id",
        },
        add: {
          type: "POST",
          endpoint: "/admin/vaccinationRegistry",
        },
        update: {
          type: "PATCH",
          endpoint: "/admin/vaccinationRegistry/",
        },
        delete: {
          type: "DELETE",
          endpoint: "/admin/vaccinationRegistry/",
        },
      },
      deworming: {
        getAll: {
          type: "GET",
          endpoint: "/admin/dewormingRegistry",
        },
        getOne: {
          type: "GET",
          endpoint: "/admin/dewormingRegistry/:id",
        },
        add: {
          type: "POST",
          endpoint: "/admin/dewormingRegistry",
        },
        update: {
          type: "PATCH",
          endpoint: "/admin/dewormingRegistry/",
        },
        delete: {
          type: "DELETE",
          endpoint: "/admin/dewormingRegistry/",
        },
      }
    },

    // App Config API

    Config: {
      getAll: {
        type: "GET",
        endpoint: "/admin/appConfig",
      },
      getOne: {
        type: "GET",
        endpoint: "/admin/appConfig/:id",
      },
      add: {
        type: "POST",
        endpoint: "/admin/appConfig",
      },
      update: {
        type: "PATCH",
        endpoint: "/admin/appConfig/:id",
      },
      delete: {
        type: "DELETE",
        endpoint: "/admin/appConfig/:id",
      },
    },

    // Food Calories API

    Food_calories: {
      getAll: {
        type: "GET",
        endpoint: "/admin/foodCalories",
      },
      getOne: {
        type: "GET",
        endpoint: "/admin/foodCalories/:id",
      },
      add: {
        type: "POST",
        endpoint: "/admin/foodCalories",
      },
      update: {
        type: "PATCH",
        endpoint: "/admin/foodCalories/",
      },
      delete: {
        type: "DELETE",
        endpoint: "/admin/foodCalories/",
      },
    },

    // Notification API

    Notification: {
      sentNotification: {
        type: "POST",
        endpoint: "/admin/notification/addNotificationToTopic",
      },
    },
  },

  TAB_MENU: {
    USER: [
      {
        no: 1,
        Label: "Pets",
        name: "pets",
        id: "pets",
        Role: [ROLES.Admin, ROLES.ClientSupport],
      },
      {
        no: 2,
        Label: "Feedback",
        name: "feedback",
        id: "feedback",
        Role: [ROLES.Admin],
      },
      // {
      //   no: 2,
      //   Label: "Mode Feedback",
      //   name: "mode",
      //   id: "mode",
      // Role: [
      //   ROLES.Admin,
      // ]
      // },
      {
        no: 3,
        Label: "Subscription",
        name: "subscription",
        id: "subscription",
        Role: [ROLES.Admin],
      },
      {
        no: 4,
        Label: "Transaction",
        name: "transaction",
        id: "transaction",
        Role: [ROLES.Admin],
      },
    ],
    PET: [
      {
        no: 1,
        Label: "Device Info",
        name: "device",
        id: "device",
        Role: [ROLES.Admin, ROLES.ClientSupport],
      },
      {
        no: 2,
        Label: "Device Error Logs",
        name: "deviceLogs",
        id: "deviceLogs",
        Role: [ROLES.Admin, ROLES.ClientSupport],
      },
      {
        no: 3,
        Label: "Feeder Info",
        name: "feeder",
        id: "feeder",
        Role: [ROLES.Admin, ROLES.ClientSupport],
      },
      {
        no: 4,
        Label: "Feeder Error Logs",
        name: "feederLogs",
        id: "feederLogs",
        Role: [ROLES.Admin, ROLES.ClientSupport],
      },
      {
        no: 5,
        Label: "Food Tracking",
        name: "food",
        id: "food",
        Role: [ROLES.Admin],
      },
      {
        no: 6,
        Label: "Weight Tracking",
        name: "weight",
        id: "weight",
        Role: [ROLES.Admin],
      },
      {
        no: 7,
        Label: "Manually Tracking",
        name: "manually",
        id: "manually",
        Role: [ROLES.Admin],
      },
      {
        no: 8,
        Label: "Mode History",
        name: "mode",
        id: "mode",
        Role: [ROLES.Admin],
      },
    ],
    DEVICES: [
      {
        no: 1,
        Label: "Device Type",
        name: "type",
        id: "type",
        Role: [ROLES.Admin, ROLES.Manufacturer],
      },
      {
        no: 2,
        Label: "Error Logs",
        name: "error",
        id: "error",
        Role: [ROLES.Admin],
      },
    ],
    MEDICINE: [
      {
        no: 1,
        Label: "Medicine",
        name: "medicine",
        id: "medicine",
        Role: [ROLES.Admin, ROLES.ClientSupport],
      },
      {
        no: 2,
        Label: "Vaccination",
        name: "vaccination",
        id: "vaccination",
        Role: [ROLES.Admin, ROLES.ClientSupport],
      },
      {
        no: 3,
        Label: "Deworming",
        name: "deworming",
        id: "deworming",
        Role: [ROLES.Admin, ROLES.ClientSupport],
      },
    ],
    FEEDER: [
      {
        no: 1,
        Label: "Feeder",
        name: "feeder",
        id: "feeder",
        Role: [ROLES.Admin, ROLES.Manufacturer],
      },
      {
        no: 2,
        Label: "Error Logs",
        name: "error",
        id: "error",
        Role: [ROLES.Admin],
      },
    ],
  },
};
export default CONSTANTS;
